export const texts = {
  heading: {
    de: 'Einstellungen',
    en: 'Settings'
  },
  profile: {
    title: {
      de: 'Profil',
      en: 'Profile'
    },
    image: {
      de: 'Profilbild',
      en: 'Profile picture'
    },
    selectImage: {
      de: 'Bild auswählen',
      en: 'Choose image'
    },
    uploadingImage: {
      de: 'Bild wird hochgeladen...',
      en: 'Uploading image...'
    },
    firstName: {
      de: 'Vorname',
      en: 'First name'
    },
    lastName: {
      de: 'Nachname',
      en: 'Last name'
    },
    email: {
      de: 'E-Mail',
      en: 'Email'
    },
    saveSuccess: {
      de: 'Die Daten wurden erfolgreich übernommen.',
      en: 'Your details have been saved successfully.'
    }
  },
  language: {
    title: {
      de: 'Sprache',
      en: 'Language'
    },
    label: {
      de: 'Sprache',
      en: 'Language'
    },
    german: {
      de: 'Deutsch',
      en: 'German'
    },
    english: {
      de: 'Englisch',
      en: 'English'
    },
    saveSuccess: {
      de: 'Die Sprache wurde erfolgreich übernommen.',
      en: 'The language has been saved successfully.'
    }
  },
  notifications: {
    title: {
      de: 'Benachrichtigungen',
      en: 'Notifications'
    },
    byMailTasks: {
      de: 'Per Mail über Aufgaben benachrichtigen',
      en: 'Notify me about tasks by email'
    },
    hideTasks: {
      de: 'Aufgaben im Portal ausblenden',
      en: 'Hide tasks in the portal'
    },
    byMailAll: {
      de: 'Per Mail über alle Aktivitäten benachrichtigen',
      en: 'Notify me about all activities by email'
    },
    saveSuccess: {
      de: 'Ihre Einstellungen wurden erfolgreich übernommen.',
      en: 'Your settings have been saved successfully.'
    }
  },
  password: {
    title: {
      de: 'Passwort ändern',
      en: 'Change password'
    },
    oldPassword: {
      de: 'Altes Passwort',
      en: 'Old password'
    },
    newPassword: {
      de: 'Neues Passwort',
      en: 'New password'
    },
    saveSuccess: {
      de: 'Das Passwort wurde erfolgreich übernommen.',
      en: 'The password has been changed successfully.'
    },
    errors: {
      missingOld: {
        de: 'Bitte altes Passwort eingeben',
        en: 'Please enter your old password'
      },
      missingNew: {
        de: 'Bitte neues Passwort eingeben',
        en: 'Please enter a new password'
      },
      generic: {
        de: 'Ein Fehler ist aufgetreten',
        en: 'An error occurred'
      }
    }
  },
  save: {
    de: 'Speichern',
    en: 'Save'
  }
};
